
import {
  computed,
  defineComponent,
  onBeforeMount,
  onMounted,
  reactive,
  ref,
  watch,
} from "vue";
import PageFrame from "@/components/common/PageFrame.vue";
import { Form } from "vee-validate";
import Button from "primevue/button";
import SelectButton from "primevue/selectbutton";
import { IPaymentInfo, IRequestPay, PaymentMethods } from "@/models/payment";
import $API from "@/services";
import { IDoctorListItem } from "@/models/doctor";
import DoctorItem from "@/components/common/Doctors/DoctorItem.vue";
import { getDoctorImage } from "@/services/doctor";
import { IRequest, RequestKindTypes } from "@/models/request";
import DateFormat from "@/utils/date-format";
import format from "@/utils/format";
import { useI18n } from "vue-i18n";

interface IPayInfo {
  PaymentInfo: IPaymentInfo;
  DoctorInfo: IDoctorListItem;
  RequestInfo: IRequest;
}
export default defineComponent({
  name: "checkout",
  props: {
    id: { type: String, required: true },
  },
  setup(props) {

    const { t } = useI18n();

    const state = reactive({
      id: props.id,
      isLoading: true,
      payInfo: {} as IPayInfo,
    });

    const receiptsTypes = ref([
      { name: "소득공제", key: 1 },
      { name: "지출증빙", key: 2 },
    ]);
    const registeredTypes = ref([
      { name: "휴대폰번호", key: 1 },
      { name: "현금영수증카드번호", key: 2 },
    ]);
    const paymentOptions = ref([
      { name: "신용카드/체크카드", value: 1 },
      { name: "계좌이체", value: 2 },
    ]);

    const payment = reactive({
      method: null,
      cashReceipts: false,
      receiptsType: 0,
      registeredType: 0,
      registeredNumber: "",
    });

    const agreeAll = ref(false);
    const agrees = reactive({
      agree1: false,
      agree2: false,
      agree3: false,
    });

    const SaveNice = async () => {
      try {
        return await $API.PaymentsService.saveNice(
          state.payInfo.PaymentInfo.OrderNumber
        );
      } catch(ex) {
        console.warn(ex);
        return false;
      }
    };

    const pay = async () => {
      try {
        if (!(await SaveNice())) return;
        if (payment.method === PaymentMethods.ACCOUNT) {
          console.log("현금결제");
        } else if (payment.method === PaymentMethods.CARD) {
          const requestPay: IRequestPay = {
            clientId: "S2_21811ca7a90c4047a464d27614137c0c",
            method: "card",
            vbankHolder: "test",
            orderId: state.payInfo.PaymentInfo.OrderNumber,
            amount: state.payInfo.PaymentInfo.PaymentAmount,
            goodsName: state.payInfo.PaymentInfo.ProductName,
            returnUrl:
              "https://localhost:44364/PohrTm/NicePayments/AuthResponseV2",
            mailReserved: "",
            fnError: (result: any) => {
              alert(result.errorMsg);
              console.error(result);
            },
          };

          console.log("requestPay", requestPay);

          $API.PaymentsService.nicepayRequestPay(requestPay);
        }
      } catch (e) {
        console.error(e);
      }
    };
    const agreeAllToggle = () => {
      agrees.agree1 = agrees.agree2 = agrees.agree3 = !agreeAll.value;
    };

    const getPaymentInfo = async () => {
      try { 
        return await $API.PaymentsService.getReady(Number.parseInt(state.id));
      } catch(ex) {
        console.warn(ex);
        return {} as IPayInfo;
      }
    };

    const requestKind = computed(() =>
      state.payInfo.RequestInfo.RequestKind === RequestKindTypes.OnlineCare
        ? t('face-to-face cooperation')
        : t('second opinion')
    );

    const scheduledDate = computed(() => {
      const date = state.payInfo.RequestInfo.ScheduledDateTime
        ? state.payInfo.RequestInfo.ScheduledDateTime
        : state.payInfo.RequestInfo.DesiredDateTime1;

      return `${DateFormat.splitDatetimeStringToString(date.valueOf())}`;
    });

    const PaymentAmount = computed(() =>
      format.moneyToString(state.payInfo.PaymentInfo.PaymentAmount)
    );

    watch(
      () => agrees,
      (n) => {
        agreeAll.value = n.agree1 && n.agree2 && n.agree3;
      },
      { deep: true }
    );

    onBeforeMount(() => {
      $API.PaymentsService.readyNicePayScript();
    });

    onMounted(async () => {
      const p = await getPaymentInfo();
      state.payInfo.PaymentInfo = p.PaymentInfo;
      state.payInfo.DoctorInfo = p.DoctorInfo;
      state.payInfo.RequestInfo = p.RequestInfo;

      state.payInfo.DoctorInfo.Image = await getDoctorImage(
        state.payInfo.DoctorInfo.DoctorKey
      );
      state.isLoading = false;

      console.log("p", p.PaymentInfo);

      console.log(state.payInfo.PaymentInfo);
    });

    return {
      state,
      payment,
      receiptsTypes,
      registeredTypes,
      paymentOptions,
      agreeAll,
      agrees,
      agreeAllToggle,
      pay,
      requestKind,
      scheduledDate,
      RequestKindTypes,
      PaymentAmount,
      t
    };
  },

  components: {
    Form,
    PageFrame,
    Button,
    SelectButton,
    // Checkbox,
    // RadioButton,
    // Dropdown,
    // InputText,
    DoctorItem,
  },
});
